/**
 * We're performing this check in an attempt to prevent the `RadioGroup`
 * component from attempting to pass down props to inner-components that are
 * not `RadioButton` components.
 *
 * The `label` and `value` props are required props, and will always be present
 * at runtime (otherwise the component won't work properly).
 *
 * For future developers: we tried several options to identify `RadioButton`
 * components prior to going this route, but they were unsuccessful. We
 * published a breaking change in metronome-ui v18.28.0 that used the
 * `displayName` attribute of the component in an attempt to uniquely identify
 * it, but we found that there are places where that attribute may be
 * overwritten and break the component functionality. This was the best
 * alternative we could think of, but we know that it's not perfect. Feel free
 * to change this in the future if a better solution is found.
 */
export var isMetronomeRadioButton = function (child) {
    // React.ReactChild is of type: React.ReactElement | number | string
    if (!child || typeof child === 'string' || typeof child === 'number') {
        return false;
    }
    // we can be confident that this is a React.ReactElement (after the check above).
    // now we can check for props that will always exist on `RadioButton` components.
    return !!(child.props.label && child.props.value);
};
//# sourceMappingURL=utils.js.map